<template>
    <div>
        <div class="tabBox">
            <el-table ref="multipleTable"
                      :data="tableData"
                      tooltip-effect="dark"
                      border
                      :header-cell-style="{ 'text-align': 'center' }"
                      :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" @row-click="handleRowClick"
                      :cell-style="{ 'text-align': 'center' }"
                      max-height="500"
                      style="padding: 5px">
                <!-- <el-table-column type="selection">
                </el-table-column> -->
                <el-table-column label="序号"
                                 type="index" />
                <el-table-column label="四级地址"
                                 prop="receiverTownName"
                                 show-overflow-tooltip>

                </el-table-column>
                <el-table-column label="运单数"
                                 width="80px"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span @click="cellClick(scope)"
                              class="numCss"
                              type="primary">{{ scope.row.qty }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="totalQty"
                                 label="件数">
                </el-table-column>
                <el-table-column prop="totalWeight"
                                 label="重量(kg)"
                                 show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="totalVolume"
                                 label="体积(m³)"
                                 show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               class="table-pagination"
                               :current-page.sync="pageNo"
                               :page-size="pageSize"
                               layout="total, prev, pager, next"
                               :total='total'>
                </el-pagination>
            </div>

        </div>
        <OrderListDialog :tableData='OrderDetail'
                         ref="showFlag" />
    </div>

</template>

<script>
import OrderListDialog from '../dialog/OrderListDialog';
import { getLeftOrderList, getOrderDetail } from '../../../../api/visualMapLayout';
import { mutations, state } from '../store.js';
export default {
    components: { OrderListDialog },
    data () {
        return {
            showFlag: false,
            pageNo: 1,
            pageSize: 20,
            total: 0,
            tableData: [],
            OrderDetail: [],
            selectedRowsData: [],
            selectMapPoinList: []
        };
    },
    props: {
        mapController: Object
    },
    computed: {
        pams () {
            return state.objPrams;
        },
        listClear () {
            return state.listClear;
        }
    },
    methods: {
        async getOrderList () {
            const parms = {
                ...this.pams,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                operateSystem: 'LSP'//区分系统
            };
            if (!parms.beginDate && !parms.endDate) return;
            await getLeftOrderList(parms).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list;
                    this.total = res.data.totalCount;
                }
            }).catch(() => {

            });
        },
        // 订单明细
        async getOrderDetail ({ row }) {
            // receiverCityCodeList、receiverDistrictCodeList、receiverProvinceCodeList、receiverTownCodeList订单列表要传详情不用传
            const data = JSON.parse(JSON.stringify(this.pams));
            delete data.receiverCityCodeList;
            delete data.receiverDistrictCodeList;
            delete data.receiverProvinceCodeList;
            delete data.receiverTownCodeList;
            const parms = {
                ...row,
                ...data,
                pageNo: 1,
                pageSize: 9999
            };
            await getOrderDetail(parms).then(res => {
                if (res && +res.code === 0) {
                    this.OrderDetail = res.data.list;
                }
            }).catch(() => {

            });
        },
        handleCurrentChange (val) {
            this.pageNo = val;
            mutations.clearOlist(true);// 清空运单列表的已选项
            this.clearMapFlag(); // 清除海量点
            this.mapController.removecandwPoitn(); // 清除客户仓库图标
            this.mapController.removecandwLabel(); // 清除label 地图序号
            this.mapController.removeAllRoutes(); // 清除导航路径
            this.getOrderList();
        },
        handleSizeChange (val) {
            this.pageSize = val;
        },
        cellClick (row) {
            this.getOrderDetail(row);
            this.$refs.showFlag.show();
        },

        handleSelectionChange(selection) {
            this.selectedRowsData = selection;
        },

        async handleRowClick (rows, cloumn) {
            mutations.clearOlist(false);// 清空运单列表的已选项
            // 点击运单列不会高亮
            if (!cloumn.property) {
                return;
            }
            const data = JSON.parse(JSON.stringify(this.pams));
            delete data.receiverCityCodeList;
            delete data.receiverDistrictCodeList;
            delete data.receiverProvinceCodeList;
            delete data.receiverTownCodeList;
            const parms = {
                ...rows,
                ...data,
                pageNo: 1,
                pageSize: 9999
            };
            const res = await getOrderDetail(parms);
            const newList = res.data.list;
            const selectMapPoinList = this.selectMapPoinList;

            // 遍历返回的数据，用taskNo筛选出对应的地图点
            newList.forEach(item => {
                const idx = selectMapPoinList.findIndex(i => i.taskNo === item.taskNo);
                if (idx > -1) {
                    // 已存在，删除
                    selectMapPoinList.splice(idx, 1);
                } else {
                    // 不存在，添加
                    selectMapPoinList.push(item);
                }
            });
            this.selectMapPoinList = selectMapPoinList;
            this.clearMapFlag(); // 清除海量点
            this.mapController.removecandwPoitn(); // 清除客户仓库图标
            this.mapController.removecandwLabel(); // 清除label 地图序号
            this.mapController.removeAllRoutes(); // 清除导航路径
            this.mapController.run((mapCtrl, logic) => {
                mapCtrl.markLabel(2, this.selectMapPoinList); // 地图序号
                mapCtrl.drawPoints(
                    ...logic.seperatePointsFromTasks(
                        this.selectMapPoinList
                    )
                ); // 海量点打点
            });
            // 当前行选中
            rows.checked = !rows.checked;
            this.$refs.multipleTable.toggleRowSelection(rows, rows.checked);
        },

        // 清除星星点点
        clearMapFlag () {
            this.$emit('clearTasks');
            this.mapController.run((mapCtrl, logic) => {
                mapCtrl.drawPoints(...logic.seperatePointsFromTasks([])); // 清空圆圈
                mapCtrl.clearSelectedPoints(); // 清除星星
            });
        },

        tableRowClassName({ row }) {
            if (this.selectedRowsData.includes(row)) {
                return 'highlight-row';
            }
        }
    },
    watch: {
        pams: function () {
            this.getOrderList();
        },

        listClear (val) {
            if (val) {
                // true时,及时清空运单列表已选项和选中行的高亮状态
                this.selectMapPoinList = [];
                this.tableData.forEach(itm => {
                    itm.checked = false;
                    this.$refs.multipleTable.toggleRowSelection(itm, itm.checked);
                });
            }
        }
    },
    mounted () {
        this.getOrderList();
    }
};
</script>

<style lang="less" scoped>
.tabBox {
    .numCss {
        color: #00bcbe;
        text-decoration: underline;

        &:hover {
            cursor: pointer;
        }
    }

    .block {
        height: 50px;

        .table-pagination {
            text-align: right;
            padding-top: 10px;
            padding: 10px;
            z-index: 111;

            .btn-prev,
            .btn-next,
            .el-pager li {
                background-color: #ffffff !important;
                border: 1px solid #cccccc;
                border-radius: 4px !important;
                padding: 0;
                min-width: 30px;
                margin-right: 4px;
            }

            .el-pager li.active + li {
                border-left: 1px solid #cccccc;
            }

            .el-pager li:not(.disabled).active {
                background-color: #00bcbf !important;
                border: 1px solid #00bcbf;
                color: #ffffff;
            }
        }
    }

    .el-table__body tr.selected-row>td {
        background: #F1F8FA !important;
    }

    .el-table__body tr.highlight-row {
        background: #e6f8f9;
    }
}
</style>